export default "__VITE_ASSET__BK7Xtd4P__"